import {
  type Address,
  checksumAddress,
  getAddress,
  isAddress,
  isAddressEqual,
  zeroAddress
} from 'viem'

export function isZeroAddress(address: Address): boolean {
  return isAddressEqual(address, zeroAddress)
}

/** Plural `getAddress`: checksum-normalize a list of addresses. */
export function getAddresses(addresses: readonly string[]): Address[] {
  return addresses.map(address => getAddress(address))
}

export function isNonZeroAddress(address: Address): boolean {
  return !isAddressEqual(address, zeroAddress)
}

/** The visible head and tail of an abbreviated address or hash, plus the hidden middle. */
export function splitAbbreviatedAddress(
  address: string,
  segLength = 4
): { head: string; middle: string; tail: string } {
  if (!address) return { head: '', middle: '', tail: '' }
  if (isAddress(address)) address = checksumAddress(address)
  if (address.length <= 2 * segLength + 2) {
    return { head: address, middle: '', tail: '' }
  }
  return {
    head: address.slice(0, segLength + 2),
    middle: address.slice(segLength + 2, segLength ? -segLength : undefined),
    tail: segLength ? address.slice(-segLength) : ''
  }
}

export function abbreviateAddress(address: string | Address, segLength = 4) {
  if (!address) return ''
  const { head, middle, tail } = splitAbbreviatedAddress(address, segLength)
  if (middle) return `${head}...${tail}`
  return `${head.slice(0, segLength + 2)}...${segLength ? head.slice(-segLength) : ''}`
}
